import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export const CartProviderByUser = "ByUser";
export const CartProviderByShipTo = "ByShipTo";
export const CartProviderByCustomer = "ByCustomer";

type CartProvider = "ByUser" | "ByShipTo" | "ByCustomer";

export interface PoolcorpSettingsModel extends BaseModel {
    customerPaymentAccountsManagementUrl: string;
    customerPaymentOptionsPortalUrl: string;
    allowInternalSignIn: boolean;
    appInsightsEnabled: boolean;
    appInsightsConnectionString: string;
    appInsightsRoleName: string;
    appInsightsCorsExcludedDomains: string[];
    azureSsoSignoutUrl: string;
    partsDefaultPageSize: number;
    paymentHistoryLookBackDays: number;
    invoiceDownloadMaximumInterval: number;
    invoiceDownloadLookBackDays: number;
    matomoEnabled: boolean;
    matomoSource: string;
    adButlerEnabled: boolean;
    adButlerId: number;
    cartProvider: CartProvider;
    theme: string;
    showGlobalQuantityInventory: boolean;
    allowTrackingPhoneNumber: boolean;
    showRetailSummitPromotions: boolean;
    disablePickupBranchSelectionByCountry: boolean;
    availabilityOnlyWarehouses: string;
    disallowedShippingBranches: string;
    filterAndOrderWarehousesForShipComplete: boolean;
    splitSubTotalForShipCompleteCountries: boolean;
    disableShippingAndHandlingByCountry: boolean;
    reorderFromInvoiceHistory: boolean;
    datePickerFormat: string;
    dateFormatDisplay: string;
    defaultPickupTimeOffset: number;
    productLinksToDisable: string;
    allowAddressValidation: boolean;
    isRestrictedPickupEnabled: boolean;
    startPickupTime: string;
    endPickupTime: string;
    allowUSAddressAutoComplete: boolean;
    allowInternationalAddressAutoComplete: boolean;
    countriesForcedToUSAutocomplete: string;
    excludedCountriesFromInternationalAutoComplete: string;
    warehousesUsingSequencing: string;
    disableACHPayments: boolean;
    disableCCPayments: boolean;
    warehousesCustomRadiusList: string;
    displayReadyByFallback: boolean;
    pickupNearbyDisplay: boolean;
    cartLineUpdateStagger: number;
    cartOptimizationEnabled: boolean;
}
